var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{staticClass:"text-h5 font-weight-bold mb-2 text--primary"},[_vm._v("Caixa")]),_c(_setup.SwitchConfig,{attrs:{"config":"CAIXA_POR_USUARIO","descricao":"Caixa Individual por Usuário","ajuda":"Dividir o caixa por usuário"}}),_c(_setup.CategoriaContasPadrao)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }